var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109 111"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89 103.6H19.9c-2.3 0-4.1-1.8-4.1-4.1h0L8.9 16.6c0-2.3 1.8-4.1 4.1-4.1h82.9c2.3 0 4.1 1.9 4.1 4.1l-6.9 82.9c.1 2.3-1.8 4.1-4.1 4.1h0z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })));
}
export default SvgCartIcon;